import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


/**------------------------------------------------------
 * Convert the URL to safeURL
 * --------------
 * Usage:
 * 	value (string type) | ngSafeURL
 * Example:
 * 	{{ videoUrl | ngSafeURL }}
 * 	Converts the passed URL to safeURL
 */
@Pipe({
    name: 'ngSafeURL',
    standalone: false
})
export class NgSafeUrlPipe implements PipeTransform {

	constructor(
		protected sanitizer: DomSanitizer
	) {}

	transform(value: string): SafeResourceUrl {
		return this.sanitizer.bypassSecurityTrustResourceUrl(value);
	}
}
